<script lang="ts">
    import WeightedScoresPage from '@Criteria/WeightedScores/Pages/WeightedScoresPage'
    export default WeightedScoresPage
</script>

<template>
    <div>
        <AttributeDeleterDialog :viewModel="attrDeleterDialog"
                                @delete-attribute="handleDeleteAttributeCommand"
                                @show-dependencies="handleShowAttributeDependencies" />

        <AttributeDependenciesDialog :viewModel="attrDependenciesDialog" />


        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <h3 v-if="!initialized"><i class="fa fa-spinner fa-spin"></i> Loading... </h3>
            <div v-if="initialized">
                <h3>Goal: {{goalName}}</h3>
                <br />
                <GoalNavigation ActivePage="weighted-scores" :WorkspaceId="workspaceId" :ProjectId="projectId" :EvalModelId="evalModelId" :ScoringEnabled="false" />

                <a class="btn btn-success" v-sanitizedHref="url_CreateWeightedScorePage">
                    Create score
                </a>
                <br />
                <br />

                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>
                                Score
                            </th>
                            <th>
                                Weights
                            </th>
                            <th>
                                Criterion
                            </th>
                            <th style="width: 90px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="s in scores" :key="s.Id">
                            <td>
                                <a class="text-dark" v-sanitizedHref="url_EditWeightedScorePage(s.Id)">
                                    <strong> {{s.Name}}</strong>
                                </a><br />
                                <small class="text-muted">
                                    {{s.Description}}
                                </small>
                            </td>
                            <td>
                                {{s.WeightsSetName}}
                            </td>
                            <td>
                                {{s.CriterionName}}
                            </td>
                            <td>
                                <div class="btn-group">
                                    <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                        Actions <span class="caret"></span>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" v-sanitizedHref="url_EditWeightedScorePage(s.Id)">Edit</a>
                                        <a class="dropdown-item" @click="handleShowAttributeDependencies(s.AttributeId)">View dependencies</a>
                                        <a class="dropdown-item" @click="handleShowAttributeDeleter(s.AttributeId)">Delete</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</template>
